import React from 'react';
import { motion } from 'framer-motion';
import doctorProfile from '../assets/doctor-profile.jpg';

const About = () => {
  return (
    <section id="about" className="py-24 bg-cream relative overflow-hidden">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image Side */}
          <motion.div 
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="relative z-10 h-[600px] w-full overflow-hidden rounded-sm shadow-xl">
              <img 
                src="https://public.youware.com/image/3da84e63-c994-4aab-814f-6069a20d55cc/p47qo35q2h.png" 
                alt="Dr. Mario Huerta Roman" 
                className="w-full h-full object-cover"
              />
            </div>
            {/* Decorative Element */}
            <div className="absolute -bottom-8 -right-8 w-64 h-64 bg-forest/5 rounded-full z-0"></div>
            <div className="absolute -top-8 -left-8 w-32 h-32 border border-divider rounded-full z-0"></div>
          </motion.div>

          {/* Content Side */}
          <motion.div 
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <span
              className="text-text-secondary font-medium tracking-widest uppercase text-sm mb-4 block"
              style={{
                color: "#4f5a33"
              }}>About The Doctor</span>
            <h2
              className="text-4xl md:text-5xl font-serif font-bold text-forest mb-8"
              style={{
                color: "#4f5a33"
              }}>Dr. Mario Huerta Roman, DC</h2>
            
            <div className="space-y-6 text-text-secondary text-lg font-light leading-relaxed">
              <p style={{
                color: "rgb(30, 30, 30)",
                textAlign: "justify"
              }}>
                Believes wholeheartedly in the body’s natural ability to heal. He creates a customized treatment plan for each patient, guided by a comprehensive understanding of the body’s systems, anatomy, and organ function.
              </p>
              <p style={{
                color: "rgb(30, 30, 30)",
                textAlign: "justify"
              }}>
                With over 15 years of experience in holistic health principles and chiropractic therapies, Dr. Huerta Roman has trained extensively in both traditional and alternative healing methods. He studied in Mexico City at the Instituto Internacional de Quirosteopatía, Masaje, Fisioterapias y Medicinas Alternas SC and at Chapingo Autonomous University, where he earned certifications in chiropractic care, physical therapy, massage therapy, acupuncture, and natural health products.
              </p>
              <p style={{
                color: "rgb(30, 30, 30)",
                textAlign: "justify"
              }}>
                Dr. Huerta Roman continued his education at San Francisco State University, where he earned a Bachelor of Arts in Raza Studies. He later pursued his chiropractic degree at Life Chiropractic College West. One of his favorite aspects of chiropractic care is its versatility and ability to support the body’s natural healing process.
              </p>
              <p style={{
                color: "rgb(30, 30, 30)",
                textAlign: "justify"
              }}>
                To further expand his knowledge and techniques, Dr. Huerta Roman has traveled internationally to Italy, China, and Dubai to study and refine his chiropractic methodology. A Sonoma County native, Dr. Huerta Roman is passionate about giving back to his community through compassionate, patient-centered care. In his free time, he enjoys traveling and swimming with his daughter and son.
              </p>
            </div>

            <div className="mt-10 pt-8 border-t border-divider">
              <div className="flex items-center gap-4">
                <div className="text-center px-6 border-r border-divider">
                  <span className="block text-3xl font-serif font-bold text-forest">10+</span>
                  <span className="text-xs uppercase tracking-wide text-text-secondary">Years Experience</span>
                </div>
                <div className="text-center px-6">
                  <span className="block text-3xl font-serif font-bold text-forest">1000+</span>
                  <span className="text-xs uppercase tracking-wide text-text-secondary">Patients Helped</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
